<template src="./kokasScanQR.html"></template>

<script>
import axios from 'axios';
import QrcodeVue from 'qrcode.vue';
import Promotions from '../home/snippet/promotions';
import SocketIO from 'socket.io-client';

const QR_CODE_LIFE_TIME = 10 * 60 * 1000;

const Config = require('~/config/default.env').default;

const socket = SocketIO(`${Config.MS_SOCKET_API_URL}/store`, { transports: ['websocket'] });

export default {
  name: 'home',
  components: {
    QrcodeVue,
    Promotions,
  },
  data() {
    return {
      qrGenTimer: null,
      getTokenTimer: null,
      promotions: '',
      isPromotionLoading: false,
    };
  },
  computed: {
    QRcode() {
      return this.$store.state.QRcode.value || '';
    },
    isVnSource() {
      return this.$route.query.isvn;
    },
    nextUrl() {
      if (this.$route.query.isvn) {
        return '/checkin-station/user-qr?isvn=true';
      } else {
        return '/checkin-station/user-qr';
      }
    },
  },
  created() {
    this.getStoreName();
    // this.getPromotion()
    this.getBackground();
    this.$store.dispatch('generateQrCode');
    socket.emit('join', this.$store.state.QRcode.value);

    // re-generate qr code every 10 minutes
    this.qrGenTimer = setInterval(() => {
      if (this.$store.state.QRcode.isLoggedIn) {
        // stop re-generation after logging in
        return clearInterval(this.qrGenTimer);
      }
      this.$store.dispatch('generateQrCode');
      socket.emit('join', this.$store.state.QRcode.value);
    }, QR_CODE_LIFE_TIME);

    /*// get user token and update session
		this.getTokenTimer = setInterval(() => {
			if (this.$store.state.QRcode.isLoggedIn) {
				// stop getting token when user is logged in
				clearInterval(this.getTokenTimer);

				// redirect to usesrScanQR
				this.$router.push({ path: "/checkin-station/user-qr" });
			}
			this.$store.dispatch("getToken");
		}, GET_TOKEN_INTERVAL);*/

    const self = this;

    socket.on('qr_code_login', function (data) {
      if (self.$store.state.QRcode.value == data.qr_code) {
        if (data.can_get_checkin_voucher) {
          self.$store.commit('voucherCode', data.can_get_checkin_voucher);
        }
        self.$store.commit('authToken', data.token);
        self.$store.dispatch('getToken', { redirect: self.nextUrl, data: self });
        socket.off('qr_code_login');
      }
    });
  },
  destroyed() {
    clearInterval(this.qrGenTimer);
  },
  methods: {
    getPromotion() {
      this.isPromotionLoading = true;
      this.$MS_SOCO_PUBLIC_API_URL
        .get('/promos')
        .then((response) => {
          if (response.status === 200) {
            this.promotions = response.data.data;
          } else {
            this.promotions = [];
          }
          this.isPromotionLoading = false;
        })
        .catch((error) => {
          this.promotions = [];
          this.isPromotionLoading = false;
          return false;
        });
    },
    getBackground() {
      // Commented this line, to prevent too many redirect if hit this endpoint
      // delete axios.defaults.withCredentials;
      axios
        .get(`${Config.MS_SOCO_PUBLIC_API_URL}/offline-store/store-cms/cover?type=cover`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data.data;

            for (const i in data) {
              if (data[i].available_screen == 'Check in Screen' && data[i].image_1) {
                this.$store.commit('setBackgroundCheckinStation', data[i].image_1);
              }
            }
            axios.defaults.withCredentials = true;
          }
        })
        .catch((error) => {});
    },
    getStoreName() {
      let name = '';
      if (Cookies.get('store_detail') && Cookies.get('store_detail') != undefined) {
        try {
          const json_data = JSON.parse(Cookies.get('store_detail'));
          name = json_data.name;
        } catch (err) {}
      }
      // if (Cookies.get('store_location_id') && Cookies.get('store_location_id') != undefined) {
      // 	for (var i in Config.store_lists) {
      // 		if (Config.store_lists[i].id == Number(Cookies.get('store_location_id'))) {
      // 			name = Config.store_lists[i].value
      // 		}
      // 	}
      // }
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'kokasScanQR';
</style>
